export const getPromptsFromString = (string) => {
    const regex = /\[([^\]]+)]/g;

    const matches = string.match(regex);

    return matches.map((match) => match.replace(/\[|\]/g, ''));
};
